import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { useIdentity } from "@/components/contexts/IdentityContext/UseIdentity";
import { LoadingDots } from "@/components/ui/LoadingDots";

const Signout = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { logout } = useIdentity();

  useEffect(() => {
    const handleSignout = async () => {
      try {
        const logoutId = searchParams.get("logoutId");

        const { redirectUrl } = await logout(logoutId ?? undefined);

        window.location.href = redirectUrl;
      } catch (error) {
        console.error("Signout failed:", error);
        navigate("/");
      }
    };

    handleSignout();
  }, [navigate, searchParams, logout]);

  return (
    <div className="flex justify-center items-center h-screen">
      <LoadingDots />
    </div>
  );
};

export default Signout;
